// 連撃3段目の得 (2026-10-12・配布版の既定の縁の光と、DEV &combo3rdBar=1 の白い残り・src/player_combo3_power.ts) を、
//   ボスの HUD (boss_hud_view.ts drawBossHudSilver) の帯の上へ出すための読み取り。描くだけ・ゲームの判定には使わない。
//   どちらも combat.ts が3段目の通常命中で出す FX (posture_hold / heavy_bar_ghost) が無ければ何も返さない = DEV ?combo3rd=off (旧) と、白い残りの DEV &combo3rdBar=1 なしでは何も出ない。
//   記録 = docs/research/2026-10-12-combo3-lock-bar-status.md。

import type { Boss, FxEvent } from './types'
import { chipFloor, roomHpFraction } from './combat'
import { HEAVY_BAR_GHOST } from './player_combo3_power'

/** 案1: 体幹の戻りが止まっている度合い (1 = 止めた直後 → 0 = 解ける)。止まっていなければ 0。
 *   ボスの戻りの猶予の残り (postureRegenLockSec) を、3段目で止めた秒で割る = 光が細り切る時に帯が減り始める。 */
export function postureHoldLevel(boss: Boss, fx: readonly FxEvent[], time: number): number {
  if (boss.state === 'staggered' || boss.posture <= 0) return 0
  const lock = boss.postureRegenLockSec ?? 0
  if (lock <= 0) return 0
  let mark: Extract<FxEvent, { kind: 'posture_hold' }> | undefined
  for (const f of fx) {
    if (f.kind === 'posture_hold' && time >= f.t && (!mark || f.t >= mark.t)) mark = f
  }
  if (!mark || mark.act !== boss.executesTaken || mark.sec <= 0) return 0
  if (time - mark.t > mark.sec + 1e-6) return 0
  return Math.max(0, Math.min(1, lock / mark.sec))
}

export type HeavyBarGhostView = {
  /** 体力の帯の割合 (0..1)。from = 3段目の前 / to = 後。 */
  hpFrom: number; hpTo: number
  /** 体幹の帯の割合 (0..1)。from = 3段目の前 / to = 後。 */
  postureFrom: number; postureTo: number
  /** 0..1。0 = 当たった瞬間、1 = 一拍 (holdSec) が過ぎた。 */
  hold: number
  /** 0..1。一拍の後に縮む (体力) / 金へ戻る (体幹) 進み。 */
  drain: number
}

function hudHpFraction(boss: Boss, hp: number): number {
  const b = { ...boss, hp }
  return hp <= chipFloor(b) ? 0 : roomHpFraction(b)
}

/** 案2: 直近の3段目で削った分の白い残り。無ければ null。 */
export function heavyBarGhost(boss: Boss, fx: readonly FxEvent[], time: number): HeavyBarGhostView | null {
  let g: Extract<FxEvent, { kind: 'heavy_bar_ghost' }> | undefined
  for (const f of fx) {
    if (f.kind === 'heavy_bar_ghost' && time >= f.t && (!g || f.t >= g.t)) g = f
  }
  if (!g || g.act !== boss.executesTaken) return null
  const age = time - g.t
  const { holdSec, drainSec } = HEAVY_BAR_GHOST
  if (age < 0 || age >= holdSec + drainSec) return null
  const mp = boss.maxPosture > 0 ? boss.maxPosture : 1
  return {
    hpFrom: hudHpFraction(boss, g.hpFrom),
    hpTo: hudHpFraction(boss, g.hpTo),
    postureFrom: Math.max(0, Math.min(1, g.postureFrom / mp)),
    postureTo: Math.max(0, Math.min(1, g.postureTo / mp)),
    hold: Math.min(1, age / holdSec),
    drain: age <= holdSec ? 0 : Math.min(1, (age - holdSec) / drainSec),
  }
}
